export interface WishlistSummaryResponse {
    itemCount?: number;
    ItemCount?: number;
    fingerprint?: string;
    Fingerprint?: string;
}

export const readWishlistSummary = (data: WishlistSummaryResponse | null | undefined) => ({
    itemCount: data && data.itemCount != null ? data.itemCount : (data && data.ItemCount != null ? data.ItemCount : 0),
    fingerprint: data && data.fingerprint ? data.fingerprint : (data && data.Fingerprint ? data.Fingerprint : 'empty'),
});
